import { Component, OnInit} from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { NgProgress } from '@ngx-progressbar/core';
import { IdleTimeoutService } from './shared/idle-timeout-service.service';
import { Store } from '@ngrx/store';
import { AppState } from 'app/reducers';
import { logout } from 'app/modules/auth/_state/auth.actions';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  constructor(private progress: NgProgress, private router: Router, private idleService: IdleTimeoutService, private store: Store<AppState>) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.ngProgress.start();  // Start the progress bar on every navigation start (including back/forward navigation)
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.ngProgress.complete();  // Complete the progress bar after navigation is done or cancelled
      }
    });
  }
  ngProgress
  ngOnInit(): void {
    this.ngProgress = this.progress.ref()
    this.idleService.startWatching(this);
  }


  ngOnDestroy(): void {
    this.idleService.stopWatching(); // Cleanup when component is destroyed
  }

  toggleErrorModal(action: string): void {
    this.errorModal = action === 'open';
  }
errorModal:boolean
dismissModal(): void {
  this.errorModal = false;
  this.store.dispatch(logout());
}

}
